export default "__VITE_PUBLIC_ASSET__b611b8f5__"